const thousandsPattern = /\B(?=(\d{3})+(?!\d))/g;

/**
 * Keeps the form value machine-readable while accepting pasted currency text.
 * The UI formats this normalized value separately, so calculations never
 * receive dollar signs or thousands separators.
 */
export function normalizeCurrencyInput(
  value: string,
  maximumFractionDigits = 2,
): string {
  const sanitized = value.replace(/[^\d.]/g, "");
  if (!sanitized) return "";

  const [integerPart = "", ...fractionParts] = sanitized.split(".");
  const integer = integerPart.replace(/^0+(?=\d)/, "") || "0";
  const hasDecimalPoint = sanitized.includes(".");
  const fraction = fractionParts.join("").slice(0, maximumFractionDigits);

  return hasDecimalPoint ? `${integer}.${fraction}` : integer;
}

export function formatCurrencyInput(
  value: string,
  maximumFractionDigits = 2,
): string {
  const normalized = normalizeCurrencyInput(value, maximumFractionDigits);
  if (!normalized) return "";

  const [integer, fraction] = normalized.split(".");
  const groupedInteger = integer.replace(thousandsPattern, ",");
  return normalized.includes(".")
    ? `${groupedInteger}.${fraction ?? ""}`
    : groupedInteger;
}
